<template>
  <div class="operation-log-container">
    <!-- 搜索区域 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>操作日志管理</span>
      </div>

      <el-row :gutter="20">
        <!-- 操作人姓名搜索 -->
        <el-col :span="6">
          <el-input
            v-model.trim="searchForm.operUserName"
            placeholder="请输入操作人姓名"
            clearable
            prefix-icon="el-icon-search"
          />
        </el-col>

        <!-- 操作类型筛选 -->
        <el-col :span="6">
          <el-select
            v-model="searchForm.operType"
            placeholder="请选择操作类型"
            clearable
            style="width: 100%"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="新增" value="C"></el-option>
            <el-option label="查询" value="R"></el-option>
            <el-option label="修改" value="U"></el-option>
            <el-option label="删除" value="D"></el-option>
          </el-select>
        </el-col>

        <!-- 操作时间范围 -->
        <el-col :span="8">
          <el-date-picker
            v-model="searchForm.operTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-col>

        <!-- 查询重置按钮 -->
        <el-col :span="4">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 日志列表表格 -->
    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="logList"
        border
        style="width: 100%"
        ref="logTable"
      >
        <el-table-column
          prop="operUserName"
          label="操作人姓名"
          width="120"
          show-overflow-tooltip
        />
        <el-table-column prop="createTime" label="操作时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="operType" label="操作类型">
          <template slot-scope="scope">
            {{ getOperTypeText(scope.row.operType) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="operModule"
          label="操作模块"
          min-width="100"
          show-overflow-tooltip
        />
        <el-table-column
          prop="operFunction"
          label="操作功能"
          min-width="100"
          show-overflow-tooltip
        />
      </el-table>

      <!-- 分页 -->
      <el-row
        style="
          margin-top: 15px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <el-pagination
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { getOperationLogList } from "@/api/community/operationLogApi";

export default {
  name: "OperationLogManage",
  data() {
    return {
      loading: false,

      // 搜索条件
      searchForm: {
        operUserName: "",
        operType: "",
        operTimeRange: [],
      },

      // 表格数据
      logList: [],

      // 分页
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    this.fetchLogList();
  },
  methods: {
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return "-";
      let timestamp = Number(dateStr);
      if (isNaN(timestamp)) {
        timestamp = new Date(dateStr).getTime();
      }
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
        .getHours()
        .toString()
        .padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
    },

    // 操作类型文字转换
    getOperTypeText(type) {
      const typeMap = {
        C: "新增",
        R: "查询",
        U: "修改",
        D: "删除",
      };
      return typeMap[type] || "未知";
    },

    // 获取日志列表
    async fetchLogList() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          operUserName: this.searchForm.operUserName,
          operType: this.searchForm.operType,
          startTime:
            (this.searchForm.operTimeRange &&
              this.searchForm.operTimeRange[0]) ||
            "",
          endTime:
            (this.searchForm.operTimeRange &&
              this.searchForm.operTimeRange[1]) ||
            "",
        };

        const res = await getOperationLogList(params);
        if (res.data.code === 0) {
          this.logList = res.data.data || [];
          this.pagination.total = res.data.total || 0;
        } else {
          this.$message.error(res.data.msg || "获取操作日志失败");
        }
      } catch (error) {
        console.error("查询操作日志异常：", error);
        this.$message.error("查询操作日志失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 查询按钮
    handleSearch() {
      this.pagination.current = 1;
      this.fetchLogList();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        operUserName: "",
        operType: "",
        operTimeRange: [],
      };
      this.handleSearch();
    },

    // 每页条数切换
    handleSizeChange(val) {
      this.pagination.size = val;
      this.fetchLogList();
    },

    // 页码切换
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.fetchLogList();
    },
  },
};
</script>

<style lang="scss" scoped>
.operation-log-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .table-card {
    .el-table {
      --el-table-header-text-color: #333;
      --el-table-row-hover-bg-color: #f5f7fa;
    }

    .el-pagination {
      text-align: right;
    }
  }
}
</style>
